import {Black, Green4, Grey17, Grey6} from "../../theme/styles";

import {EnlilTable} from "../EnlilTable";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import {formatLocal} from "../../util/Formatters";
import EventBus from "../../util/EventBus";
import {IconButton, Menu, MenuItem, Typography} from "@mui/material";
import {Edit, MoreVert} from "@mui/icons-material";
import css_self from "../Navigation/css/NavBar.module.scss";
import React from "react";
import DeveloperCredentialFormApplet from "../../eoec/applet/impl/RestManagement/DeveloperCredentialFormApplet";
import {withAppContext} from "../../util/withAppContext";

class DeveloperCredentialTable extends EnlilTable {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("developer-credential-form-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("developer-credential-form-applet-save", this.onCancelHandler);
    }

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("developer-credential-form-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("developer-credential-form-applet-save", this.onCancelHandler);
    }

    enterpriseComponentInsertCompleted(ec) {
        super.enterpriseComponentInsertCompleted(ec)

        ec.invalidateChildren();
    }

    getCellRenderer(name) {
        if (name === "Status Cell") {
            return this.renderStatusCell;
        } else if (name === "Action Cell") {
            return this.renderActionCell;
        } else if (name === "API Key Cell") {
            return this.renderAPIKeyCell;
        }

        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "New Credential") {
            this.setState({renderTarget: "New Credential"});
        }
        super.handleMenuClick(identifier);
    }

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderActionCell = (___, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let action = (
            <div style={{width: "50px", marginTop: "-4px", backgroundColor: "#FFFFFF", marginLeft: "-10px", marginRight: "-20px", paddingBottom: "5px", paddingLeft: "4px"}}>
                <IconButton onClick={(event) => {
                    if (this.state.tableActionMenuTarget === null) {
                        this.setState({tableActionMenuTarget: event.currentTarget});
                    } else {
                        this.setState({tableActionMenuTarget: null});
                    }
                }}>
                    <MoreVert/>
                </IconButton>
                <Menu anchorEl={this.state.tableActionMenuTarget}
                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                      transformOrigin={{vertical: -10, horizontal: "center"}}
                      open={this.state.tableActionMenuTarget !== null && this.state.tableActionMenuTarget !== undefined}
                      onClose={() => this.setState({tableActionMenuTarget: null})}
                      TransitionProps={{
                          onExited: () => this.setState({tableActionMenuTarget: null}),
                      }}
                      MenuListProps={{
                          ...{"data-cc-component": "NavMenu"},
                          disablePadding: true,
                          style: {"minWidth": "200px"},
                      }}
                      PaperProps={{
                          elevation: 2,
                      }}
                >
                    <MenuItem divider className={css_self.Standard} onClick={() => {
                        this.setState({tableActionMenuTarget: null, renderTarget: "Edit Credential"});
                    }}>
                        <Edit style={{color: Grey6}}/>
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Edit Credential</Typography>
                    </MenuItem>
                </Menu>
            </div>
        )

        if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("DeveloperApplication").getAttributeValue("Active") === false) {
            action = null;
        }

        if (this.state.buffer[params.row.id]["Active"] === false) {
            action = null;
        }

        return (
            <>
                {action}
            </>
        )
    }

    renderAPIKeyCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let applicationActive = this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("DeveloperApplication").getAttributeValue("Active");
        let textColor = applicationActive === true ? this.state.buffer[params.row.id].get("Active") === true ? Black : Grey6: Grey6

        return (
            <div style={{marginTop: "0px"}}>
                <div style={{fontSize: 14, color: textColor, height: "20px"}}>{this.state.buffer[params.row.id].get("APIKey")}</div>
            </div>
        );
    };

    renderExtension() {
        if (this.state.renderTarget === "Edit Credential") {
            return <DeveloperCredentialFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} availableModes={["Edit", "New", "View"]} defaultAction="Edit" />;
        } else if (this.state.renderTarget === "New Credential") {
            return <DeveloperCredentialFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} availableModes={["Edit", "New", "View"]} defaultAction="New" />;
        }
    };

    renderStatusCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let status;
        let datetime;

        let applicationActive = this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("DeveloperApplication").getAttributeValue("Active");

        if (this.state.buffer[params.row.id].get("Active") === true) {
            status = "Active"
            datetime = formatLocal(this.state.buffer[params.row.id].get("CreatedDatetime"))
        } else {
            status = "Inactive"
            datetime = formatLocal(this.state.buffer[params.row.id].get("DeactivationDatetime"))
        }

        let checkColor = applicationActive === true ? (status === "Active" ? Green4 : Grey6) : Grey6
        let textColor = applicationActive === true ? this.state.buffer[params.row.id].get("Active") === true ? Black : Grey6 : Grey6

        return (
            <div style={{marginTop: "-11px"}}>
                <div style={{fontSize: 14, color: checkColor, height: "20px"}}>{status}</div>
                <div style={{fontSize: 11, color: textColor, height: "20px"}}>{datetime}</div>
            </div>
        );
    };

    shouldRenderMenuItem(identifier) {
        if (identifier === "New Credential" || identifier === "Refresh") {
            return this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("DeveloperApplication").getTotalRowcount() > 0;
        }
        return true;
    }
}

export default withNavigate(withAppContext(withBreakpoint(DeveloperCredentialTable)));